import type { RouteObject } from "react-router-dom";
import { Navigate } from "react-router-dom";
import NotFound from "../pages/NotFound";
import LoginPage from "../pages/login/page";
import UnifiedDashboard from "../pages/dashboard/page";
import CommandeNouvellePage from "../pages/commande-nouvelle/page";
import VenteTissu from "../pages/vente-tissu/page";
import GestionStocks from "../pages/gestion-stocks/page";
import PaiePersonnel from "../pages/paie-personnel/page";
import GestionUtilisateurs from "../pages/gestion-utilisateurs/page";
import CommandeDetail from "../pages/commande-detail/page";
import StocksNouveau from "../pages/stocks-nouveau/page";
import DashboardSuperAdmin from "../pages/dashboard-superadmin/page";
import GestionMesures from "../pages/gestion-mesures/page";
import ParametresMesures from "../pages/parametres-mesures/page";
import CatalogueModeles from "../pages/catalogue-modeles/page";
import ParametresPersonnel from "../pages/parametres-personnel/page";
import Rapports from "../pages/rapports/page";
import HistoriqueClients from "../pages/historique-clients/page";
import ParametresEntreprise from "../pages/parametres-entreprise/page";
import ProductionPage from "../pages/production/page";
import FournisseurPage from "../pages/fournisseurs/page";
import FinancesPage from "../pages/finances/page";

import ParametresHabitTypes from "../pages/parametres-habit-types/page";

const routes: RouteObject[] = [
  { path: "/", element: <Navigate to="/login" replace /> },
  { path: "/login", element: <LoginPage /> },
  { path: "/dashboard", element: <UnifiedDashboard /> },
  { path: "/dashboard/vendeur", element: <Navigate to="/dashboard" replace /> },
  { path: "/dashboard/gerant", element: <Navigate to="/dashboard" replace /> },
  { path: "/dashboard/atelier", element: <Navigate to="/dashboard" replace /> },
  { path: "/dashboard/coupeur", element: <Navigate to="/dashboard" replace /> },
  { path: "/dashboard/tailleur", element: <Navigate to="/dashboard" replace /> },
  { path: "/dashboard/superadmin", element: <DashboardSuperAdmin /> },
  { path: "/commande/nouvelle", element: <CommandeNouvellePage /> },
  { path: "/commande/:id", element: <CommandeDetail /> },
  { path: "/vente-tissu", element: <VenteTissu /> },
  { path: "/stocks", element: <GestionStocks /> },
  { path: "/stocks/nouveau", element: <StocksNouveau /> },
  { path: "/paie", element: <PaiePersonnel /> },
  { path: "/finances", element: <FinancesPage /> },
  { path: "/fournisseurs", element: <FournisseurPage /> },
  { path: "/utilisateurs", element: <GestionUtilisateurs /> },
  { path: "/mesures", element: <GestionMesures /> },
  { path: "/rapports", element: <Rapports /> },
  { path: "/catalogue-modeles", element: <CatalogueModeles /> },
  { path: "/parametres/mesures", element: <ParametresMesures /> },
  { path: "/parametres/habit-types", element: <ParametresHabitTypes /> },
  { path: "/parametres/personnel", element: <ParametresPersonnel /> },
  { path: "/clients/historique", element: <HistoriqueClients /> },
  { path: "/parametres/entreprise", element: <ParametresEntreprise /> },
  { path: "/production", element: <ProductionPage /> },
  { path: "*", element: <NotFound /> },
];

export default routes;
